/**
 * @param {string} str
 * @returns {string}
 */
export function toTitleCase(str) {
    let parts = str.split(' ');
    parts = parts.map(s => s.charAt(0).toUpperCase() + s.slice(1));
    return parts.join(' ');
}

/**
 * @param {string} str
 * @param {string} [delimiter=' '] - '$' not allowed
 * @returns {string}
 */
export function splitTitleCase(str, delimiter = ' ') {
    return str.replace(/([^A-Z])([A-Z])/g, `$1${delimiter}$2`);
}

/**
 * @param {string} str
 * @returns {string}
 */
export function camelToSnakeCase(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
}


/**
 * @param {string} str
 * @returns {string}
 */
export function snakeToCamelCase(str) {
    return str.replace(/-([a-z])/g, (m, p1) => p1.toUpperCase());
}

/**
 * @params {string} str
 * @returns {object} details
 * @returns {string} details.url
 * @returns {string} details.[contentType]
 * @returns {string} details.[encoding]
 * @returns {string} details.[data]
 */
export function parseDataUrl(str) {
    // Regex taken from:
    // https://gist.github.com/bgrins/6194623
    const regex = /data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*)/i;
    //const regex = /data:(.*?)?(;base64)?,(.*?)/;

    const match = str.match(regex);
    if (!match) {
        throw new Error('failed to parse data url');
    }

    let encoding;
    if (match[2] && match[2].startsWith(';charset=')) {
        encoding = match[2].split('=')[1];
    }
    if (match[3] === ';base64') {
        encoding = 'base64';
    }

    return {
        url:         match[0],
        contentType: match[1],
        encoding:    encoding,
        data:        match[4],
    };
}

/**
 * Modified from:
 * https://stackoverflow.com/a/16245768
 *
 * @param {string} str
 * @param {string} [contentType='']
 * @returns {Blob}
 */
function base64ToBlob(b64Data, contentType = '') {
    const sliceSize = 512;

    const byteChars = atob(b64Data);
    const byteArrays = [];

    for (let i = 0; i < byteChars.length; i += sliceSize) {
        const slice = byteChars.slice(i, i + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let j = 0; j < slice.length; j++) {
            byteNumbers[j] = slice.charCodeAt(j);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

/**
 * @param {string} str
 * @returns {string}
 */
function ensureUrlFormatting(str) {
    if (str.includes('http://') || str.includes('https://')) return str;
    return 'http://' + str;
}


function shortId(prefix = "", random = false) {
    const sec = Date.now() * 1000 + Math.random() * 1000;
    const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
    return `${prefix}${id}${random ? `_${Math.trunc(Math.random() * 100000000)}`:""}`;
};

function isValidUrl(string) {
  var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  return (res !== null)
};

function isValidImage(url) {
    if (!url) { return false }

    url = url.toLowerCase();
    
    return url.endsWith('.jpeg') ||
            url.endsWith('.jpg') ||
            url.endsWith('.gif') ||
            url.endsWith('.png') ||
            url.endsWith('.webp') ||
            url.endsWith('.jfif') ||
            url.endsWith('.bmp') 
}


export default {
    toTitleCase,
    splitTitleCase,
    camelToSnakeCase,
    snakeToCamelCase,
    parseDataUrl,
    base64ToBlob,
    ensureUrlFormatting,
    shortId,
    isValidUrl,
    isValidImage,
}



// WEBPACK FOOTER //
// ./src/utils/strings.js